<div class="sentiment-details-top-themes" [class.sentiment-details-top-themes--single-col]="showPositive !== showNegative">
  <div class="sentiment-details-top-themes__col sentiment-details-top-themes__col--positive" *ngIf="showPositive">
    <h4 class="sentiment-details-top-themes__title">Top positive themes</h4>
    <p class="sentiment-details-top-themes__subtitle">Top {{ themeLimit }} themes and top {{ subThemeLimitPerTheme }} sub-themes within each</p>
    <div class="sentiment-details-top-themes__list" *ngIf="positiveThemesWithSubThemes.length; else noPositive">
      <div *ngFor="let t of positiveThemesWithSubThemes" class="sentiment-details-top-themes__theme-card sentiment-details-top-themes__theme-card--positive">
        <div class="sentiment-details-top-themes__theme-header">
          <strong class="sentiment-details-top-themes__theme-name">{{ t.themeName }}</strong>
          <div class="sentiment-details-top-themes__theme-meta">
            <span class="sentiment-details-top-themes__count sentiment-details-top-themes__count--positive">+{{ t.count | number }}</span>
            <span class="sentiment-details-top-themes__percent">{{ t.percentOfSentiment }}% of positive</span>
          </div>
        </div>
        <div class="sentiment-details-top-themes__subthemes" *ngIf="t.subThemes.length">
          <div class="sentiment-details-top-themes__subthemes-label">Top sub-themes:</div>
          <ul class="sentiment-details-top-themes__subthemes-list">
            <li *ngFor="let s of t.subThemes" class="sentiment-details-top-themes__subthemes-item">
              {{ s.subThemeName }} (<span class="sentiment-details-top-themes__count sentiment-details-top-themes__count--positive">+{{ s.count | number }}</span>)
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ng-template #noPositive>
      <p class="sentiment-details-top-themes__empty">No positive theme data</p>
    </ng-template>
  </div>
  <div class="sentiment-details-top-themes__col sentiment-details-top-themes__col--negative" *ngIf="showNegative">
    <h4 class="sentiment-details-top-themes__title">Top negative themes</h4>
    <p class="sentiment-details-top-themes__subtitle">Top {{ themeLimit }} themes and top {{ subThemeLimitPerTheme }} sub-themes within each</p>
    <div class="sentiment-details-top-themes__list" *ngIf="negativeThemesWithSubThemes.length; else noNegative">
      <div *ngFor="let t of negativeThemesWithSubThemes" class="sentiment-details-top-themes__theme-card sentiment-details-top-themes__theme-card--negative">
        <div class="sentiment-details-top-themes__theme-header">
          <strong class="sentiment-details-top-themes__theme-name">{{ t.themeName }}</strong>
          <div class="sentiment-details-top-themes__theme-meta">
            <span class="sentiment-details-top-themes__count sentiment-details-top-themes__count--negative">-{{ t.count | number }}</span>
            <span class="sentiment-details-top-themes__percent">{{ t.percentOfSentiment }}% of negative</span>
          </div>
        </div>
        <div class="sentiment-details-top-themes__subthemes" *ngIf="t.subThemes.length">
          <div class="sentiment-details-top-themes__subthemes-label">Top sub-themes:</div>
          <ul class="sentiment-details-top-themes__subthemes-list">
            <li *ngFor="let s of t.subThemes" class="sentiment-details-top-themes__subthemes-item">
              {{ s.subThemeName }} (<span class="sentiment-details-top-themes__count sentiment-details-top-themes__count--negative">-{{ s.count | number }}</span>)
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ng-template #noNegative>
      <p class="sentiment-details-top-themes__empty">No negative theme data</p>
    </ng-template>
  </div>
</div>
